export const socialLinks = [
  { name: 'Twitter', icon: 'ri-twitter-x-line', href: 'https://twitter.com/jeff500180' },
  { name: 'Instagram', icon: 'ri-instagram-line', href: 'https://instagram.com/jeff500180' },
  { name: 'WhatsApp', icon: 'ri-whatsapp-line', href: 'https://wa.me/jeff500180' },
  { name: 'Line', icon: 'ri-line-line', href: 'https://line.me/ti/p/8y78a2ZQhe' },
  { name: 'Telegram', icon: 'ri-telegram-line', href: 'https://t.me/jeff500180' },
];